import { FC, useEffect, useState } from "react"
import { PhotoProvider } from "react-photo-view"
import { toast } from "react-toastify"

import { useTranslation } from "react-i18next"

import { FileViewer } from "components/fileviewer/FileViewer"
import { InputField } from "components/inputs/InputField"

import { URL } from "constants/api/requests"

import { kycService } from "services/kyc/kyc.service"

import { Modal } from "./Modal"

import "react-photo-view/dist/react-photo-view.css"

interface IProps {
  data?: string
  open: boolean
  handler: any
  declineHandler: any
  approveHandler: any
}

export const ModalKYCFiles: FC<IProps> = (props) => {
  const { data: user_id, open, handler, declineHandler, approveHandler } = props
  const { t }: { t: any } = useTranslation(["translation"], { useSuspense: false })
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    if (user_id) {
      getKYCFilesData(user_id)
      checkDuplicate(user_id)
    }
  }, [user_id])

  const checkDuplicate = async (user_id: string) => {
    const { duplicate } = await kycService.getDuplicateRecord(user_id)
    if (duplicate) {
      toast.info("Duplicates detected")
    }
  }

  const getKYCFilesData = async (user_id: string) => {
    const { data: kycData } = await kycService.getKYCFiles(user_id)
    if (kycData) setData(kycData)
  }

  return (
    <Modal open={open} handler={handler}>
      <div className="relative flex flex-col justify-between modal-box max-w-full">
        <PhotoProvider>
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <InputField title={t("kyc.firstName")} value={data?.user.personal_profile.first_name} disabled />
            <InputField title={t("kyc.lastName")} value={data?.user.personal_profile.last_name} disabled />
            <InputField title={t("kyc.birthday")} value={data?.user.personal_profile.dob} disabled />
            <InputField title={t("kyc.country")} value={data?.user.personal_profile.country} disabled />
            <InputField title={t("kyc.postcode")} value={data?.user.personal_profile.zip} disabled />
            <InputField title={t("kyc.city")} value={data?.user.personal_profile.city} disabled />
            <InputField title={t("kyc.address")} value={data?.user.personal_profile.address} disabled />
            <InputField title={t("kyc.address2")} value={data?.user.personal_profile.address2} disabled />

            <FileViewer title={t("kyc.idcardFront")} path={data?.kycSignedImages.img_idcard_front} />
            <FileViewer title={t("kyc.idcardBack")} path={data?.kycSignedImages.img_idcard_back} />
            <FileViewer title={t("kyc.proofAddress")} path={data?.kycSignedImages.doc_proof_address} />
            <FileViewer title={t("kyc.additionalDocument")} path={data?.kycSignedImages.doc_add_verify} />

            <div className="w-full form-control text-left">
              <div
                className="cursor-pointer font-semibold"
                onClick={() => {
                  if (data?.user_id) {
                    // navigate(URL.USER.replace(":id", data.user_id))
                    window.open(URL.USER.replace(":id", data.user_id), "_blank") // open at new page
                  }
                }}
              >
                {t("kyc.viewProfile")}
              </div>
            </div>
          </div>
          <div className="modal-action">
            <button
              className="btn btn-primary"
              onClick={() => {
                handler()
                declineHandler(data)
              }}
            >
              {t("common.decline")}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                handler()
                approveHandler(data)
              }}
            >
              {t("common.approve")}
            </button>
          </div>
        </PhotoProvider>
      </div>
    </Modal>
  )
}
